
const Intervals = (function() {
	let _intervals: IInterval[] = []; // Array of object in format { name, execute, period },

	const Get = () => _intervals;

	const Start = (options: IIntervalOptions) => {
		if (!options || !options.name || !options.execute || !options.period) {
			throw new Error('Missing option(s)');
		}

		const intervalAlreadyExists = _intervals.filter((i) => i.name === options.name).length > 0;

		if (intervalAlreadyExists) {
			Stop(options.name);
		}

		_intervals.push({
			name: options.name,
			id: window.setInterval(options.execute, options.period)
		});
	};

	const Stop = (intervalName: string) => {
		const interval = _intervals.find((interval) => interval.name === intervalName);

		if (interval) {
			clearInterval(interval.id);
		}

		_intervals = _intervals.filter((interval) => interval.name !== intervalName);
	};

	return {
		Get,
		Start,
		Stop
	};
})();

export default Intervals;

interface IIntervalOptions {
	name: string;
	execute: () => void;
	period: number;
}

interface IInterval {
	name: string;
	id: number;
}
